import { CssClasses as MentionCssClasses } from "Mention/Scripts/TFS.Mention";
import * as MentionAutocomplete from "Mention/Scripts/TFS.Mention.Autocomplete";
import { WikiPage } from "TFS/Wiki/Contracts";
import { startsWith } from "VSS/Utils/String";
import { isPageWithoutAssociatedContent } from "Wiki/Scripts/WikiPagesHelper";

export class WikiPagePathsProvider {
    private _wikiPagePaths: IPromise<string[]>;
    private readonly MAX_FILTERED_PAGES = 50;

    constructor(
        private _getAllPagesDelegate: () => IPromise<WikiPage[]>,
        private _transformedPagePath: (path: string) => string,
        private _pagePathPrefix = "",
        private _excludeLocallyAddedPages = false,
        private _excludePagePathsWithoutAssociatedContent = false
    ) {}

    public getArtifactType(): string {
        return "WikiPage";
    }

    public search(term: string): JQueryPromise<MentionAutocomplete.ISearchResult<string>[]> {
        const deferred = $.Deferred<MentionAutocomplete.ISearchResult<string>[]>();
        const foundWikiPages: MentionAutocomplete.ISearchResult<string>[] = [];

        // This variable we are using to filter pages as user continues to type
        const linkText = term.substr(term.indexOf("(") + 1);

        this._getWikiPagePaths().then(
            (wikiPageItems) => {
                for (let index = 0; index < wikiPageItems.length; index++) {
                    const wikiPage = wikiPageItems[index];
                    // Show all pages when path is empty, start to filter once we have more chars
                    const wikiPageLowercase = wikiPage.toLocaleLowerCase();
                    const linkTextLowerCase = linkText.toLocaleLowerCase();
                    if (
                        linkText.length === 0 ||
                        wikiPageLowercase.indexOf(linkTextLowerCase) >= 0 ||
                        this._transformedPagePath(wikiPageLowercase).indexOf(linkTextLowerCase) >= 0
                    ) {
                        foundWikiPages.push({ original: wikiPage, highlighted: wikiPage });
                        // limit the total results to MAX_FILTERED_PAGES, as rendering of complete results is too slow
                        if (foundWikiPages.length >= this.MAX_FILTERED_PAGES) {
                            break;
                        }
                    }
                }
                deferred.resolve(foundWikiPages);
            },
            (reject) => {
                deferred.reject.apply(deferred, reject);
            }
        );

        return deferred.promise();
    }

    private _getWikiPagePaths(): IPromise<string[]> {
        if (!this._wikiPagePaths) {
            this._wikiPagePaths = this._getAllPagesDelegate().then((pages) => {
                const wikiPages: string[] = [];

                pages.forEach((page) => {
                    if (this._excludePagePathsWithoutAssociatedContent && isPageWithoutAssociatedContent(page)) {
                        return;
                    }

                    if (this._excludeLocallyAddedPages && (page.url == null || page.url == "")) {
                        return;
                    }

                    const pagePath = page.path;
                    pagePath && startsWith(pagePath, this._pagePathPrefix) && wikiPages.push(pagePath);
                });

                // Remove "/" from the list of pages
                const indexOfRootDirectory = wikiPages.indexOf("/");
                if (indexOfRootDirectory >= 0) {
                    wikiPages.splice(indexOfRootDirectory, 1);
                }
                return wikiPages;
            });
        }

        return this._wikiPagePaths;
    }
}

export class WikiPathsAutoCompleteProviderUtils {
    // Used to render the selected suggestion
    public static renderSuggestion(ul: JQuery, suggestion: MentionAutocomplete.ISearchResult<string>): JQuery {
        const li = $("<li/>").appendTo(ul);
        li.attr("title", suggestion.highlighted);

        const $a = $("<a/>").appendTo(li);

        const pagePathItem = $("<span/>").addClass(MentionCssClasses.AUTOCOMPLETE_TITLE).text(suggestion.highlighted);

        pagePathItem.appendTo($a);
        return li;
    }
}
